import React, { useState, useEffect } from 'react'
import CategoryService from '../../../services/category';
import SpinnerLoad from '../../components/Main/SpinnerLoad/SpinnerLoad';
import BodyCategory from '../../components/Category/BodyCategory';
import InputMain from '../../components/Main/InputMain';
import { simpleAlerts } from '../../../utils/alerts';
import { CODES } from '../../../utils/httpCodes';
import _ from 'lodash';

const newCategory = {
    "nombre": "",
    "editable": 0,
    "estado": 1
}

const Category = () => {
    const url = window.location.pathname;
    const [titleLoad, setTitleLoad] = useState('Carga Inicial ...');
    const [openLoad, setOpenLoad] = useState(true);
    const handleOpenLoad = () => setOpenLoad(true);
    const handleCloseLoad = () => setOpenLoad(false);

    const [search, setSearch] = useState("");
    const [categories, setCategories] = useState(null);

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        Promise.all([
            getCategory(),
        ]).then(() => { handleCloseLoad(); setTitleLoad(null) });
    }

    const getCategory = async () => {
        try {
            handleOpenLoad();
            setTitleLoad('Listando categorias ...');
            const result = await CategoryService.getCategory(url);
            if (result.status === CODES.SUCCESS_200)
                setCategories(result.data);
            else
                simpleAlerts('No se encontro categorias', 'info');
            return []
        } catch (error) {
            console.log(`Error en getCategory: ${error}`);
        } finally {
            handleCloseLoad();
            setTitleLoad(null);
        }
    }

    const addCategory = () => {
        let updData = _.cloneDeep(categories);
        updData.push(newCategory);
        return setCategories(updData);
    }

    return (
        <div className='container'>
            <SpinnerLoad open={openLoad} title={titleLoad} />
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-6 d-flex justify-content-center">
                        <InputMain
                            title={'Buscar categoria'}
                            placeholder={'nombre'}
                            width={'50%'}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <div className="d-flex justify-content-center align-items-end">
                            <button type="button" className="btn btn-outline-warning mx-4"
                                onClick={addCategory}
                                title='Crear Categoria'
                            ><i className="fa-solid fa-circle-plus"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row justify-content-center'>
                <div className='col-md-8'>
                    <BodyCategory
                        handleOpenLoad={handleOpenLoad}
                        handleCloseLoad={handleCloseLoad}
                        setTitleLoad={setTitleLoad}
                        getCategory={getCategory}

                        data={categories}
                        setData={setCategories}
                        search={search}
                    />
                </div>
            </div>
        </div>
    )
}

export default Category